export enum FormNameType {
  CalculationForm = 'Formularz kalkulacji',
}
